/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Th4Inputs */

const en_mk_cmp_linear_th4 = /** @type {(inputs: Mk_Cmp_Linear_Th4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The human assignee stays accountable; spend limits exist, a per-action approval gate we did not find.`)
};

const id_mk_cmp_linear_th4 = /** @type {(inputs: Mk_Cmp_Linear_Th4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manusia penanggung jawab tetap bertanggung jawab; batas belanja ada, gerbang approval per aksi tidak kami temukan.`)
};

/**
* | output |
* | --- |
* | "The human assignee stays accountable; spend limits exist, a per-action approval gate we did not find." |
*
* @param {Mk_Cmp_Linear_Th4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_th4 = /** @type {((inputs?: Mk_Cmp_Linear_Th4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Th4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_th4(inputs)
	return en_mk_cmp_linear_th4(inputs)
});